import { useEffect } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'

import useAuth from '../../hooks/useAuth'
import useLang from '../../hooks/useLang'
import useTranslate from '../../hooks/useTranslate'

// import `ChakraProvider` component
import { css, Box, Grid, GridItem, Center, HStack, VStack, Spacer, Container, Badge, Icon, Image, Button, Text, useDisclosure } from '@chakra-ui/react'
import { TableContainer, Table, Thead, Tbody, Tfoot, Tr, Th, Td } from '@chakra-ui/react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'

// import `ChakraProvider` icon
import { AddIcon } from '@chakra-ui/icons'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe, faEarthAmericas, faCity, faRing, faDungeon, faUsers, faLink, faTicket } from "@fortawesome/free-solid-svg-icons"


import PulseLoader from 'react-spinners/PulseLoader'


//const DASH_REGEX = /^\/dash(\/)?$/
const DASH_REGEX = /^\/dash(\/)?$/
const USERS_REGEX = /^\/dash\/users.*?$/
const NOTES_REGEX = /^\/dash\/notes.*?$/
const MARKETS_REGEX = /^\/dash\/markets.*?$/
const COUNTRIES_REGEX = /^\/dash\/countries.*?$/
const CITIES_REGEX = /^\/dash\/cities.*?$/
const VENUES_REGEX = /^\/dash\/venues.*?$/
const MAPS_REGEX = /^\/dash\/maps.*?$/
const CUSTOMERS_REGEX = /^\/dash\/customers.*?$/


const Welcome = () => {

    const { username, isManager, isAdmin } = useAuth()

    const { lang } = useLang()
    const { T } = useTranslate(lang)

    const navigate = useNavigate()
    const { pathname } = useLocation()

    const date = new Date()
    const today = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(date)




    const goEventyFindlist = () => navigate('/dash/events/finder')

    const goSources = () => navigate('/dash/sources')
    const goCustomers = () => navigate('/dash/customers')
    const goTickets = () => navigate('/dash/tickets')
    const goMaps = () => navigate('/dash/maps')
    const goVenues = () => navigate('/dash/venues')
    const goCities = () => navigate('/dash/cities')
    const goCountries = () => navigate('/dash/countries')
    const goMarkets = () => navigate('/dash/markets')
    const goNotes = () => navigate('/dash/notes')
    const goUsers = () => navigate('/dash/users')

    let dashClass = null
    if (!DASH_REGEX.test(pathname) && !USERS_REGEX.test(pathname) && !NOTES_REGEX.test(pathname) && !MARKETS_REGEX.test(pathname) && !COUNTRIES_REGEX.test(pathname) && !CITIES_REGEX.test(pathname) && !VENUES_REGEX.test(pathname) && !MAPS_REGEX.test(pathname) && !CUSTOMERS_REGEX.test(pathname)) {
        dashClass = "dash-header__container--small"
    }

    const content = (
        <>
            <Center bg='#45413C' p='0' color='white' axis='both'>
                <Grid colSpan={12} w='95vw' maxW='3000' gap={5} p='5' templateColumns='repeat(12, 1fr)'>

                    <GridItem color='black' colSpan={{ base: "12", sm: "12", md: "12", lg: "12", xl: "12" }}>
                        <Grid templateColumns='repeat(12, 1fr)' gap={2}>

                            <GridItem colSpan={{ base: "9", sm: "9", md: "9", lg: "9", xl: "9" }}>
                                <Box h='400' borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                                    <HStack>
                                        <Box p='2' textAlign={['left']} >
                                            <Text color='black' fontSize={{ base: "20", sm: "20", md: "20", lg: "24", xl: "28" }} fontWeight={700}>CARTY</Text><Text mt="-2" color='black' fontSize={{ base: "12", sm: "12", md: "15", lg: "15", xl: "15" }} fontWeight={400}>LAST</Text>
                                        </Box>
                                        <Spacer />
                                        <Box p='2' textAlign={['right']}>
                                            <Button size='sm' leftIcon={<AddIcon />} color='white' colorScheme='red' variant='solid' _hover={{ bg: 'gray.100', color: 'red.500', borderWidth: '1px', borderColor: 'red.500' }}>
                                                <Text display={{ base: 'none', sm: 'flex' }} fontSize={16} fontWeight={600}>ADD</Text>
                                            </Button>
                                        </Box>
                                    </HStack>

                                    <Tabs mt="2" variant='soft-rounded' isFitted>
                                        <TabList
                                            overflowX="auto"
                                            css={css({
                                                scrollbarWidth: 'none',
                                                '::-webkit-scrollbar': { display: 'none' },
                                                '-webkit-overflow-scrolling': 'touch',
                                                boxShadow: 'inset 0 -2px 0 rgba(0, 0, 0, 0.1)',
                                                border: '0 none',
                                            })}
                                        >
                                            <Tab _selected={{ color: 'white', bg: 'red.300' }} _hover={{ bg: 'gray.300', color: 'black', borderColor: 'gray.300' }} m={1} fontSize={18} fontWeight={700}>FR</Tab>
                                            <Tab _selected={{ color: 'white', bg: 'red.300' }} _hover={{ bg: 'gray.300', color: 'black', borderColor: 'gray.300' }} m={1} fontSize={18} fontWeight={700}>CH</Tab>
                                            <Tab _selected={{ color: 'white', bg: 'red.300' }} _hover={{ bg: 'gray.300', color: 'black', borderColor: 'gray.300' }} m={1} fontSize={18} fontWeight={700}>PT</Tab>
                                            <Tab _selected={{ color: 'white', bg: 'red.300' }} _hover={{ bg: 'gray.300', color: 'black', borderColor: 'gray.300' }} m={1} fontSize={18} fontWeight={700}>ES</Tab>
                                            <Tab _selected={{ color: 'white', bg: 'red.300' }} _hover={{ bg: 'gray.300', color: 'black', borderColor: 'gray.300' }} m={1} fontSize={18} fontWeight={700}>IT</Tab>
                                            <Tab _selected={{ color: 'white', bg: 'red.300' }} _hover={{ bg: 'gray.300', color: 'black', borderColor: 'gray.300' }} m={1} fontSize={18} fontWeight={700}>DE</Tab>
                                            <Tab _selected={{ color: 'white', bg: 'red.300' }} _hover={{ bg: 'gray.300', color: 'black', borderColor: 'gray.300' }} m={1} fontSize={18} fontWeight={700}>BE</Tab>
                                        </TabList>

                                        <TabPanels>

                                            <TabPanel>
                                                <TableContainer>
                                                    <Table
                                                        variant='striped'
                                                        size='sm'
                                                    >
                                                        <Thead>
                                                            <Tr>
                                                                <Th>EVENT</Th>
                                                                <Th>DATE</Th>
                                                                <Th>VENUE</Th>
                                                                <Th>CART</Th>
                                                                <Th>TICKET</Th>
                                                                <Th></Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>
                                                            <Tr>
                                                                <Td><strong>Bruce Springsteen</strong></Td>
                                                                <Td>2024-05-25</Td>
                                                                <Td>Orange Velodrome (FR)</Td>
                                                                <Td>36</Td>
                                                                <Td>122</Td>
                                                                <Td>Open</Td>
                                                            </Tr>

                                                        </Tbody>
                                                    </Table>
                                                </TableContainer>
                                            </TabPanel>

                                            <TabPanel>
                                                <TableContainer>
                                                    <Table
                                                        variant='striped'
                                                        size='sm'
                                                    >
                                                        <Thead>
                                                            <Tr>
                                                                <Th>WEBSITE</Th>
                                                                <Th>EVENT</Th>
                                                                <Th>DATE</Th>
                                                                <Th>VENUE</Th>
                                                                <Th>CART</Th>
                                                                <Th>TICKET</Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>
                                                            <Tr>
                                                                <Td>TM</Td>
                                                                <Td><strong>Pablo Sanchez</strong></Td>
                                                                <Td>2024-07-10</Td>
                                                                <Td>Stadium Madrid (ES)</Td>
                                                            </Tr>
                                                        </Tbody>
                                                    </Table>
                                                </TableContainer>
                                            </TabPanel>

                                            <TabPanel>
                                                <p>No found !</p>
                                            </TabPanel>

                                        </TabPanels>
                                    </Tabs>

                                </Box>
                            </GridItem>

                            <GridItem colSpan={{ base: "3", sm: "3", md: "3", lg: "3", xl: "3" }}>
                                <Box h='400' borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                                    <HStack>
                                        <Box p='2' textAlign={['left']} >
                                            <Text color='black' fontSize={{ base: "20", sm: "20", md: "20", lg: "24", xl: "28" }} fontWeight={700}>CAPTCHY</Text><Text mt="-2" color='black' fontSize={{ base: "12", sm: "12", md: "15", lg: "15", xl: "15" }} fontWeight={400}>LAST</Text>
                                        </Box>
                                        <Spacer />
                                        <Box p='2' textAlign={['right']}>
                                            <Button size='sm' leftIcon={<AddIcon />} color='white' colorScheme='red' variant='solid' _hover={{ bg: 'gray.100', color: 'red.500', borderWidth: '1px', borderColor: 'red.500' }}>
                                                <Text display={{ base: 'none', sm: 'flex' }} fontSize={16} fontWeight={600}>ADD</Text>
                                            </Button>
                                        </Box>
                                    </HStack>
                                    <TableContainer>
                                        <Table
                                            size='sm'
                                            variant='striped'
                                        >
                                            <Thead>
                                                <Tr>
                                                    <Th>VENUE</Th>
                                                    <Th>EVENT</Th>
                                                    <Th>DATE</Th>
                                                    <Th isNumeric>FILEMAP</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                                <Tr>
                                                    <Td><strong>Stade de France</strong></Td>
                                                    <Td>Coldplay</Td>
                                                    <Td>2023-07-12</Td>
                                                    <Td isNumeric>fr_sdf_coldplay_2023</Td>
                                                </Tr>
                                            </Tbody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </GridItem>

                            <GridItem colSpan={{ base: "12", sm: "12", md: "12", lg: "12", xl: "12" }}>
                                <Box h='700' borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                                    <HStack>
                                        <Box p='2' textAlign={['left']} >
                                            <Text color='black' fontSize={{ base: "20", sm: "20", md: "20", lg: "24", xl: "28" }} fontWeight={700}>STOCKY</Text><Text mt="-2" color='black' fontSize={{ base: "12", sm: "12", md: "15", lg: "15", xl: "15" }} fontWeight={400}>LAST</Text>
                                        </Box>
                                        <Spacer />
                                        <Box p='2' textAlign={['right']}>
                                            <Button size='sm' leftIcon={<AddIcon />} color='white' colorScheme='red' variant='solid' _hover={{ bg: 'gray.100', color: 'red.500', borderWidth: '1px', borderColor: 'red.500' }}>
                                                <Text display={{ base: 'none', sm: 'flex' }} fontSize={16} fontWeight={600}>ADD</Text>
                                            </Button>
                                        </Box>
                                    </HStack>
                                    <TableContainer>
                                        <Table
                                            size='sm'
                                            variant='striped'
                                        >
                                            <Thead>
                                                <Tr>
                                                    <Th>EVENT / VENUE</Th>
                                                    <Th>TICKET</Th>
                                                    <Th>CAT / SECTION / SEAT</Th>
                                                    <Th isNumeric>TOTAL / U.PRICE</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                            </Tbody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </GridItem>

                            <GridItem colSpan={{ base: "12", sm: "12", md: "6", lg: "6", xl: "6" }}>
                                <Box borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                                    <HStack>
                                        <Box p='2' textAlign={['left']} >
                                            <Text color='black' fontSize={{ base: "20", sm: "20", md: "20", lg: "24", xl: "28" }} fontWeight={700}>SALES</Text><Text mt="-2" color='black' fontSize={{ base: "12", sm: "12", md: "15", lg: "15", xl: "15" }} fontWeight={400}>LAST</Text>
                                        </Box>
                                        <Spacer />
                                        <Box p='2' textAlign={['right']}>
                                            <Button size='sm' leftIcon={<AddIcon />} color='white' colorScheme='red' variant='solid' _hover={{ bg: 'gray.100', color: 'red.500', borderWidth: '1px', borderColor: 'red.500' }}>
                                                <Text display={{ base: 'none', sm: 'flex' }} fontSize={16} fontWeight={600}>ADD</Text>
                                            </Button>
                                        </Box>
                                    </HStack>
                                    <TableContainer>
                                        <Table
                                            size='sm'
                                            variant='striped'
                                        >
                                            <Thead>
                                                <Tr>
                                                    <Th>EVENT / VENUE</Th>
                                                    <Th>TICKET</Th>
                                                    <Th>CAT / SECTION / SEAT</Th>
                                                    <Th isNumeric>TOTAL / U.PRICE</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                            </Tbody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </GridItem>

                            <GridItem colSpan={{ base: "12", sm: "12", md: "6", lg: "6", xl: "6" }}>
                                <Box borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                                    <HStack>
                                        <Box p='2' textAlign={['left']} >
                                            <Text color='black' fontSize={{ base: "20", sm: "20", md: "20", lg: "24", xl: "28" }} fontWeight={700}>PURCHASES</Text><Text mt="-2" color='black' fontSize={{ base: "12", sm: "12", md: "15", lg: "15", xl: "15" }} fontWeight={400}>LAST</Text>
                                        </Box>
                                        <Spacer />
                                        <Box p='2' textAlign={['right']}>
                                            <Button size='sm' leftIcon={<AddIcon />} color='white' colorScheme='red' variant='solid' _hover={{ bg: 'gray.100', color: 'red.500', borderWidth: '1px', borderColor: 'red.500' }}>
                                                <Text display={{ base: 'none', sm: 'flex' }} fontSize={16} fontWeight={600}>ADD</Text>
                                            </Button>
                                        </Box>
                                    </HStack>
                                    <TableContainer>
                                        <Table
                                            size='sm'
                                            variant='striped'
                                        >
                                            <Thead>
                                                <Tr>
                                                    <Th>EVENT / VENUE</Th>
                                                    <Th>TICKET</Th>
                                                    <Th>CAT / SECTION / SEAT</Th>
                                                    <Th isNumeric>TOTAL / U.PRICE</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                                <Tr>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>Bruce Springsteen</Text>
                                                        <Text fontSize={14} fontWeight={400}>Stade de France (FR)</Text>
                                                        <Text fontSize={12} fontWeight={400}>2024-07-12 - 20:00</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={18} fontWeight={700}>x2</Text>
                                                    </Td>
                                                    <Td>
                                                        <Text fontSize={17} fontWeight={700}>CATEGORIE 1</Text>
                                                        <Text fontSize={14} fontWeight={400}>Section 417, Rang 30</Text>
                                                    </Td>
                                                    <Td isNumeric>
                                                        <Text fontSize={17} fontWeight={700}>157€</Text>
                                                        <Text fontSize={14} fontWeight={400}>78.5€</Text>
                                                    </Td>
                                                </Tr>
                                            </Tbody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </GridItem>

                        </Grid>
                        <br />
                        <Grid templateColumns='repeat(10, 1fr)' gap={2}>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goMarkets} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faGlobe} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>2</Badge>{T.dash.Markets}</Text>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goCountries} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faEarthAmericas} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>21</Badge>{T.dash.Countries}</Text>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goCities} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faCity} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>73</Badge>{T.dash.Cities}</Text>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goVenues} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faRing} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>258</Badge>{T.dash.Venues}</Text>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goMaps} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faDungeon} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>165</Badge>{T.dash.Maps}</Text>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goTickets} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faTicket} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>741</Badge>{T.dash.Tickets}</Text>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goCustomers} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faUsers} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>840</Badge>{T.dash.Customers}</Text>
                                </Box>
                            </GridItem>
                            <GridItem colSpan={{ base: "5", sm: "5", md: "2", lg: "2", xl: "2" }}>
                                <Box onClick={goSources} cursor={'pointer'} borderRadius='xl' p={2} fontSize={20} fontWeight={400} textAlign={['center']} color='black' border='10px' borderColor='black' bg='#333333' _hover={{ bg: 'red.600', color: 'white', borderColor: 'red.600' }} w="100%">
                                    <FontAwesomeIcon color='white' fontSize={30} icon={faLink} />
                                    <Text color='white' fontSize={{ base: "18", sm: "18", md: "12", lg: "18", xl: "20" }} fontWeight={600}><Badge mr='1'>261</Badge>{T.dash.Sources}</Text>
                                </Box>
                            </GridItem>
                        </Grid>
                    </GridItem>

                </Grid>

            </Center>

            <br />
            <h1>Test</h1>
            <p><Link to="/dash/maps/mapSvg">MapSvg</Link></p>
        </>

    )

    return content
}
export default Welcome